const config_settings = {
  "localhost:3001": {
    ENV: "INT",
    IR_URL: "https://integration.myinspection.report/",
    RW_URL: "https://integration.report-writer.yourinspection.app/",
    UNBOUNCE_URL: "https://try.palmtech.com/free-trial/",
    SERVER_URL: "https://int-portal-api.yourinspection.app/public/index.php/api",
    REPORT_SETTING_URL: "https://int-report-api.myinspection.report/public/index.php/api",
    SUPABASE_URL:"https://msueltejrabjnvqheylo.supabase.co",
    SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY ?? "",
    PORTAL_URL:"https://integration.palmtech.dev"
  },
  "localhost:3000": {
    ENV: "DEV",
    IR_URL: "https://develop.myinspection.report/",
    RW_URL: "https://develop.report-writer.yourinspection.app/",
    UNBOUNCE_URL: "https://try.palmtech.com/free-trial/",
    SERVER_URL: "https://dev-portal-api.yourinspection.app/public/index.php/api",
    REPORT_SETTING_URL: "https://dev-report-api.myinspection.report/public/index.php/api",
    WRW_SERVER: "https://dev-rw-api.yourinspection.app/public/index.php/api",
    SUPABASE_URL:"https://msueltejrabjnvqheylo.supabase.co",
    SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY ?? "",
    PORTAL_URL:"https://develop.palmtech.dev"
  },
  "localhost:3002": {
    ENV: "DEV",
    IR_URL: "https://develop.myinspection.report/",
    RW_URL: "https://develop.report-writer.yourinspection.app/",
    UNBOUNCE_URL: "https://try.palmtech.com/free-trial/",
    SERVER_URL: "https://dev-portal-api.yourinspection.app/public/index.php/api",
    REPORT_SETTING_URL: "https://dev-report-api.myinspection.report/public/index.php/api",
    WRW_SERVER: "https://dev-rw-api.yourinspection.app/public/index.php/api",
    SUPABASE_URL:"https://msueltejrabjnvqheylo.supabase.co",
    SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY ?? "",
    PORTAL_URL:"https://develop.palmtech.dev"
  },
  "develop.palmtech.com": {
    ENV: "DEV",
    IR_URL: "https://develop.myinspection.report/",
    RW_URL: "https://develop.report-writer.yourinspection.app/",
    UNBOUNCE_URL: "https://try.palmtech.com/free-trial/",
    SERVER_URL: "https://palmtechdevelop.yourinspection.report/public/index.php/api",
    REPORT_SETTING_URL: "https://dev-report-api.myinspection.report/public/index.php/api",
    WRW_SERVER: "https://dev-rw-api.yourinspection.app/public/index.php/api",
    SUPABASE_URL:"https://msueltejrabjnvqheylo.supabase.co",
    SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY ?? "",
    PORTAL_URL:"https://develop.palmtech.dev"
  },
  "develop.palmtech.dev": {
    ENV: "DEV",
    IR_URL: "https://develop.myinspection.report/",
    RW_URL: "https://develop.report-writer.yourinspection.app/",
    UNBOUNCE_URL: "https://try.palmtech.com/free-trial/",
    SERVER_URL: "https://dev-portal-api.yourinspection.app/public/index.php/api",
    REPORT_SETTING_URL: "https://dev-report-api.myinspection.report/public/index.php/api",
    WRW_SERVER: "https://dev-rw-api.yourinspection.app/public/index.php/api",
    SUPABASE_URL:"https://msueltejrabjnvqheylo.supabase.co",
    SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY ?? "",
    PORTAL_URL:"https://develop.palmtech.dev"
  },
  "integration.dci019jvejs84.amplifyapp.com": {
    ENV: "INT",
    IR_URL: "https://integration.myinspection.report/",
    RW_URL: "https://integration.report-writer.yourinspection.app/",
    UNBOUNCE_URL: "https://try.palmtech.com/free-trial/",
    SERVER_URL: "https://int-portal-api.yourinspection.app/public/index.php/api",
    REPORT_SETTING_URL: "https://int-report-api.myinspection.report/public/index.php/api",
    WRW_SERVER: "https://int-rw-api.yourinspection.app/public/index.php/api",
    SUPABASE_URL:"https://msueltejrabjnvqheylo.supabase.co",
    SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY ?? "",
    PORTAL_URL:"https://integration.palmtech.dev"
  },
  "integration.palmtech.dev": {
    ENV: "INT",
    IR_URL: "https://integration.myinspection.report/",
    RW_URL: "https://integration.report-writer.yourinspection.app/",
    UNBOUNCE_URL: "https://try.palmtech.com/free-trial/",
    SERVER_URL: "https://int-portal-api.yourinspection.app/public/index.php/api",
    REPORT_SETTING_URL: "https://int-report-api.myinspection.report/public/index.php/api",
    WRW_SERVER: "https://int-rw-api.yourinspection.app/public/index.php/api",
    SUPABASE_URL:"https://msueltejrabjnvqheylo.supabase.co",
    SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY ?? "",
    PORTAL_URL:"https://integration.palmtech.dev"
  },
  "staging.palmtech.com": {
    ENV: "STAGE",
    IR_URL: "https://staging.myinspection.report/",
    RW_URL: "https://staging.report-writer.yourinspection.app/",
    UNBOUNCE_URL: "https://try.palmtech.com/free-trial/",
    SERVER_URL: "https://stg-portal-api.palmtech.com/public/index.php/api",
    REPORT_SETTING_URL: "https://stg-report-api.myinspection.report/public/index.php/api",
    WRW_SERVER: "https://stg-rw-api.yourinspection.app/public/index.php/api",
    SUPABASE_URL:"https://msueltejrabjnvqheylo.supabase.co",
    SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY ?? "",
    PORTAL_URL:"https://staging.palmtech.com"
  },
  "portal.palmtech.com": {
    ENV: "PROD",
    IR_URL: "https://myinspection.report/",
    RW_URL: "https://report-writer.yourinspection.app/",
    UNBOUNCE_URL: "https://try.palmtech.com/free-trial/",
    SERVER_URL: "https://prod-portal-api.palmtech.com/public/index.php/api",
    REPORT_SETTING_URL: "https://prod-report-api.myinspection.report/public/index.php/api",
    WRW_SERVER: "https://prod-rw-api.yourinspection.app/public/index.php/api",
    SUPABASE_URL:"https://msueltejrabjnvqheylo.supabase.co",
    SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY ?? "",
    PORTAL_URL:"https://portal.palmtech.com"
  },
  "$PRID-ngp.palmtechpr.com": {
    ENV: "DEV",
    IR_URL: "https://develop.myinspection.report/",
    RW_URL: "https://develop.report-writer.yourinspection.app/",
    UNBOUNCE_URL: "https://try.palmtech.com/free-trial/",
    SERVER_URL: "https://dev-portal-api.yourinspection.app/public/index.php/api",
    REPORT_SETTING_URL: "https://dev-report-api.myinspection.report/public/index.php/api",
    WRW_SERVER: "https://dev-rw-api.yourinspection.app/public/index.php/api",
    SUPABASE_URL:"https://msueltejrabjnvqheylo.supabase.co",
    SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY ?? "",
    PORTAL_URL:"https://integration.palmtech.dev"
  },
};

export default config_settings;
